

<template>
  <ul class="header_social">
    <li v-for="(menu, key) in socialMenus" :key="key">
      <router-link :to="menu.link">
        <i v-bind:class="menu.cssClass"></i>
      </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'TopSocialMenu',
  data() {
    return {
      socialMenus: [
        {
          link: '#',
          cssClass: 'fab fa-facebook-f'
        },
        {
          link: '#',
          cssClass: 'fab fa-instagram'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menus/TopSocialMenu.vue